var giftWraps = document.querySelectorAll('[name="gift_wrap_selector"]');
var giftWrapLabels = document.querySelectorAll('.gift_wrap label');

giftWrapLabels.forEach(function (label) {
  label.addEventListener('click', function (e) {
    var element = e.currentTarget;
    var input = element.closest('div').querySelector('input');

    if (input) {
      if (input.checked) {
        var matchingRemove = document.querySelector(`.btn-remove[data-variant="${input.dataset.variant}"]`);

        if (matchingRemove) {
          matchingRemove.click();
        }
      }
    }
  });
});

giftWraps.forEach(function (wrap) {
  wrap.addEventListener('change', function (e) {
    if (e.currentTarget.checked) {
      updateGiftWrapping(e.currentTarget.dataset.variant);
    }
  });
});

async function updateGiftWrapping(variantId) {
  var cartInfo = await $.getJSON('/cart.json');
  var allGiftWrappingIds = document.querySelectorAll(`[name="gift_wrap_selector"]:not([data-variant="${variantId}"])`);
  var wrapping = [];

  for (var i = 0; i < cartInfo.items.length; i++) {
    var item = cartInfo.items[i];

    if (item.variant_id == variantId) {
      wrapping.push(item);
    }
  }
  
  // Build the update object
  var updates = {
    updates: {}
  }

  updates.updates[variantId] = 1;

  for (var wrapping of allGiftWrappingIds) {
    updates.updates[wrapping.dataset.variant] = 0;
  }

  try {
    var result = await new Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();
      request.open('POST', '/cart/update.js', true);
      request.setRequestHeader('Content-Type', 'application/json');
  
      request.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(request.reponse)
        } else {
          reject({
            status: this.status,
            statusText: this.statusText
          });
        }
      }
      request.onerror = function () {
        reject({
          status: this.status,
          statusText: this.statusText
        });
      }
  
      request.send(JSON.stringify(updates));
    });

    window.location.reload();
  } catch (ex) {
    console.error('An error occurred updating the cart!', ex);
  }
}